import React, { Component } from "react";
import {
  Button,
  Container,
  Row, Form,
  Col,
  Offcanvas,
} from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from '../config.json';
import { ValidationUtils } from '../Sidebar/Common';

import LoadingOverlay from "./LoadingOverlay";
export default class Tw_uat_master extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      data: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      errors: {},
      touched: {}, // Track which fields have been touched
      filteredData: null,
      tableClms: [
        {
          name: "S.NO",
          selector: (row, i) => row.tw_uat_master_Id,
          sortable: true,
          cell: (row) => <span>{row.tw_uat_master_Id}</span>,
        },
        { name: "Num Manufacturer Code", selector: (row, i) => row.num_manufacturercode, sortable: true, cell: (row) => <span>{row.num_manufacturercode}</span>, }, { name: "Txt Manufacturer Name", selector: (row, i) => row.txt_manufacturername, sortable: true, cell: (row) => <span>{row.txt_manufacturername}</span>, }, { name: "Number Model Code", selector: (row, i) => row.num_mode_code, sortable: true, cell: (row) => <span>{row.num_mode_code}</span>, }, { name: "Text Model Name", selector: (row, i) => row.txt_model_name, sortable: true, cell: (row) => <span>{row.txt_model_name}</span>, }, { name: "Number Model Variant Code", selector: (row, i) => row.num_model_varient_code, sortable: true, cell: (row) => <span>{row.num_model_varient_code}</span>, }, { name: "Text Model Varient", selector: (row, i) => row.txt_model_varient, sortable: true, cell: (row) => <span>{row.txt_model_varient}</span>, }, { name: "Number Product", selector: (row, i) => row.num_product, sortable: true, cell: (row) => <span>{row.num_product}</span>, }, { name: "Text Status", selector: (row, i) => row.txt_status, sortable: true, cell: (row) => <span>{row.txt_status}</span>, }, { name: "Date Start Date", selector: (row, i) => row.dat_start_date, sortable: true, cell: (row) => <span>{row.dat_start_date}</span>, }, { name: "Date Enddate", selector: (row, i) => row.dat_end_date, sortable: true, cell: (row) => <span>{row.dat_end_date}</span>, }, { name: "Number Vehicle Class", selector: (row, i) => row.num_vehicle_class, sortable: true, cell: (row) => <span>{row.num_vehicle_class}</span>, }, { name: "Number Vehicle Sub Class", selector: (row, i) => row.num_vehicle_sub_class, sortable: true, cell: (row) => <span>{row.num_vehicle_sub_class}</span>, }, { name: "Text Body Type", selector: (row, i) => row.txt_body_type, sortable: true, cell: (row) => <span>{row.txt_body_type}</span>, }, { name: "Number Body Type", selector: (row, i) => row.num_body_type, sortable: true, cell: (row) => <span>{row.num_body_type}</span>, }, { name: "Text Segment", selector: (row, i) => row.txt_segment, sortable: true, cell: (row) => <span>{row.txt_segment}</span>, }, { name: "Number Segement", selector: (row, i) => row.num_segement, sortable: true, cell: (row) => <span>{row.num_segement}</span>, }, { name: "Number Fuel Type", selector: (row, i) => row.num_fuel_type, sortable: true, cell: (row) => <span>{row.num_fuel_type}</span>, }, { name: "Text Fuel Type", selector: (row, i) => row.txt_fuel_type, sortable: true, cell: (row) => <span>{row.txt_fuel_type}</span>, }, { name: "Number Cubic Capacity", selector: (row, i) => row.num_cubic_capacity, sortable: true, cell: (row) => <span>{row.num_cubic_capacity}</span>, }, { name: "Number Seating Capacity", selector: (row, i) => row.num_seating_capacity, sortable: true, cell: (row) => <span>{row.num_seating_capacity}</span>, }, { name: "Number Carrying Capacity", selector: (row, i) => row.num_carrying_capacity, sortable: true, cell: (row) => <span>{row.num_carrying_capacity}</span>, }, { name: "Number Gross Vehicle Weight", selector: (row, i) => row.num_gross_vehicle_weight, sortable: true, cell: (row) => <span>{row.num_gross_vehicle_weight}</span>, }, { name: "DummyOne", selector: (row, i) => row.dummyOne, sortable: true, cell: (row) => <span>{row.dummyOne}</span>, }, { name: "dummyTwo", selector: (row, i) => row.dummyTwo, sortable: true, cell: (row) => <span>{row.dummyTwo}</span>, }, { name: "dummyThree", selector: (row, i) => row.dummyThree, sortable: true, cell: (row) => <span>{row.dummyThree}</span>, },
        //***tableClms
        {
          name: "Actions",
          sortable: false,
          cell: (row) => (
            <div>
              {/* edit button and delete button */}
              <Button
                style={{ marginRight: "10px" }}
                variant="primary"
                onClick={() => this.Tw_uat_mastereditHandler(row)}
                className="bi bi-pen"
              >
              </Button>
              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              >
              </Button>
            </div>
          ),
        },
      ],
      currentPage: 1,
      itemsPerPage: 10,
      isEditing: false,
      tw_uat_master_Id: "",
      num_manufacturercode: '', txt_manufacturername: '', num_mode_code: '', txt_model_name: '', num_model_varient_code: '', txt_model_varient: '', num_product: '', txt_status: '', dat_start_date: '', dat_end_date: '', num_vehicle_class: '', num_vehicle_sub_class: '', txt_body_type: '', num_body_type: '', txt_segment: '', num_segement: '', num_fuel_type: '', txt_fuel_type: '', num_cubic_capacity: '', num_seating_capacity: '', num_carrying_capacity: '', num_gross_vehicle_weight: '', dummyOne: '', dummyTwo: '', dummyThree: '',
      //***state
    };
  }

  // Enhanced validation method using Common.js with auto-generated logic
  validateField = (fieldName, value, fieldConfig) => {
    const { inputType, validationOptions } = fieldConfig;
    const fieldDisplayName = fieldConfig.displayName || fieldName;

    let validationResult = { isValid: true, message: "" };

    // Auto-generated validation based on inputType and validationOptions
    switch (inputType.toLowerCase()) {
      case 'text':
        if (validationOptions?.isName) {
          validationResult = ValidationUtils.validateName(value);
        } else if (validationOptions?.isAddress) {
          validationResult = ValidationUtils.validateAddress(value);
        } else if (validationOptions?.maxLength) {
          validationResult = ValidationUtils.validateLength(value, parseInt(validationOptions.maxLength), fieldDisplayName);
        } else {
          validationResult = { isValid: true, message: "" };
        }
        break;

      case 'mail':
      case 'email':
        validationResult = ValidationUtils.validateEmail(value);
        break;

      case 'telephone':
      case 'phone':
        validationResult = ValidationUtils.validatePhone(value);
        break;

      case 'number':
        validationResult = ValidationUtils.validateNumber(value, fieldDisplayName);
        break;

      case 'dob_child':
        validationResult = ValidationUtils.validateDOBMinAge(value);
        break;

      case 'dob_adult':
        validationResult = ValidationUtils.validateDOBAdult(value);
        break;

      case 'pan':
        validationResult = ValidationUtils.validatePAN(value);
        break;

      case 'aadhaar':
        validationResult = ValidationUtils.validateAadhaar(value);
        break;

      case 'password':
        if (value.length < 6) {
          validationResult = { isValid: false, message: "Password must be at least 6 characters long" };
        }
        break;

      default:
        validationResult = { isValid: true, message: "" };
    }

    // Check required field validation
    if (validationOptions?.isRequired && (!value || value.toString().trim() === "")) {
      validationResult = ValidationUtils.validateRequired(value, fieldDisplayName);
    }

    const errors = { ...this.state.errors };
    if (!validationResult.isValid) {
      errors[fieldName] = validationResult.message;
    } else {
      delete errors[fieldName];
    }

    this.setState({ errors });
    return validationResult.isValid;
  };

  // Enhanced field change handler with auto-validation
  handleFieldChange = (fieldName, value, fieldConfig) => {
    this.setState({
      [fieldName]: value,
      touched: { ...this.state.touched, [fieldName]: true }
    });

    // Only validate if field has been touched
    if (this.state.touched[fieldName] || value !== "") {
      this.validateField(fieldName, value, fieldConfig);
    }
  };

  // Enhanced field blur handler for validation
  handleFieldBlur = (fieldName, value, fieldConfig) => {
    this.setState({
      touched: { ...this.state.touched, [fieldName]: true }
    });
    this.validateField(fieldName, value, fieldConfig);
  };

  // Check if form is valid - auto-generated based on required fields
  isFormValid = () => {
    const { errors } = this.state;

    // Auto-generated required field validation
    // No required fields defined


    return Object.keys(errors).length === 0;
  };

  // Auto-generated validation for all fields before submission
  validateAllFields = () => {
    const fieldConfigs = [
      { fieldName: 'num_manufacturercode', inputType: 'Text', displayName: 'Num Manufacturer Code', validationOptions: { isRequired: false } },
      { fieldName: 'txt_manufacturername', inputType: 'Text', displayName: 'Txt Manufacturer Name', validationOptions: { isRequired: false } },
      { fieldName: 'num_mode_code', inputType: 'Text', displayName: 'Number Model Code', validationOptions: { isRequired: false } },
      { fieldName: 'txt_model_name', inputType: 'Text', displayName: 'Text Model Name', validationOptions: { isRequired: false } },
      { fieldName: 'num_model_varient_code', inputType: 'Text', displayName: 'Number Model Variant Code', validationOptions: { isRequired: false } },
      { fieldName: 'txt_model_varient', inputType: 'Text', displayName: 'Text Model Varient', validationOptions: { isRequired: false } },
      { fieldName: 'num_product', inputType: 'Text', displayName: 'Number Product', validationOptions: { isRequired: false } },
      { fieldName: 'txt_status', inputType: 'Text', displayName: 'Text Status', validationOptions: { isRequired: false } },
      { fieldName: 'dat_start_date', inputType: 'Date', displayName: 'Date Start Date', validationOptions: { isRequired: false } },
      { fieldName: 'dat_end_date', inputType: 'Date', displayName: 'Date Enddate', validationOptions: { isRequired: false } },
      { fieldName: 'num_vehicle_class', inputType: 'Text', displayName: 'Number Vehicle Class', validationOptions: { isRequired: false } },
      { fieldName: 'num_vehicle_sub_class', inputType: 'Text', displayName: 'Number Vehicle Sub Class', validationOptions: { isRequired: false } },
      { fieldName: 'txt_body_type', inputType: 'Text', displayName: 'Text Body Type', validationOptions: { isRequired: false } },
      { fieldName: 'num_body_type', inputType: 'Text', displayName: 'Number Body Type', validationOptions: { isRequired: false } },
      { fieldName: 'txt_segment', inputType: 'Text', displayName: 'Text Segment', validationOptions: { isRequired: false } },
      { fieldName: 'num_segement', inputType: 'Text', displayName: 'Number Segement', validationOptions: { isRequired: false } },
      { fieldName: 'num_fuel_type', inputType: 'Text', displayName: 'Number Fuel Type', validationOptions: { isRequired: false } },
      { fieldName: 'txt_fuel_type', inputType: 'Text', displayName: 'Text Fuel Type', validationOptions: { isRequired: false } },
      { fieldName: 'num_cubic_capacity', inputType: 'Text', displayName: 'Number Cubic Capacity', validationOptions: { isRequired: false } },
      { fieldName: 'num_seating_capacity', inputType: 'Text', displayName: 'Number Seating Capacity', validationOptions: { isRequired: false } },
      { fieldName: 'num_carrying_capacity', inputType: 'Text', displayName: 'Number Carrying Capacity', validationOptions: { isRequired: false } },
      { fieldName: 'num_gross_vehicle_weight', inputType: 'Text', displayName: 'Number Gross Vehicle Weight', validationOptions: { isRequired: false } },
      { fieldName: 'dummyOne', inputType: 'Text', displayName: 'DummyOne', validationOptions: { isRequired: false } },
      { fieldName: 'dummyTwo', inputType: 'Text', displayName: 'dummyTwo', validationOptions: { isRequired: false } },
      { fieldName: 'dummyThree', inputType: 'Text', displayName: 'dummyThree', validationOptions: { isRequired: false } }
    ];

    fieldConfigs.forEach(config => {
      const value = this.state[config.fieldName];
      this.validateField(config.fieldName, value, config);
    });

    const touched = {};
    fieldConfigs.forEach(config => {
      touched[config.fieldName] = true;
    });
    this.setState({ touched });

  };

  // offcanvas Open
  handleOffcanvasShow = () => {
    this.setState({
      show: true,
      errors: {},
      touched: {},
      num_manufacturercode: '', txt_manufacturername: '', num_mode_code: '', txt_model_name: '', num_model_varient_code: '', txt_model_varient: '', num_product: '', txt_status: '', dat_start_date: '', dat_end_date: '', num_vehicle_class: '', num_vehicle_sub_class: '', txt_body_type: '', num_body_type: '', txt_segment: '', num_segement: '', num_fuel_type: '', txt_fuel_type: '', num_cubic_capacity: '', num_seating_capacity: '', num_carrying_capacity: '', num_gross_vehicle_weight: '', dummyOne: '', dummyTwo: '', dummyThree: '',
    });
  };

  // Offcanvas close button
  handleOffcanvasClose = () => {
    this.setState({
      show: false,
      isEditing: false,
      errors: {},
      touched: {},
      num_manufacturercode: '', txt_manufacturername: '', num_mode_code: '', txt_model_name: '', num_model_varient_code: '', txt_model_varient: '', num_product: '', txt_status: '', dat_start_date: '', dat_end_date: '', num_vehicle_class: '', num_vehicle_sub_class: '', txt_body_type: '', num_body_type: '', txt_segment: '', num_segement: '', num_fuel_type: '', txt_fuel_type: '', num_cubic_capacity: '', num_seating_capacity: '', num_carrying_capacity: '', num_gross_vehicle_weight: '', dummyOne: '', dummyTwo: '', dummyThree: '',
    });
  };

  // Enhanced toast notifications
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg);
        break;
      default:
        toast.info(msg);
    }
  };

  Tw_uat_mastereditHandler = (row) => {
    this.setState({
      isEditing: true,
      show: true,
      tw_uat_master_Id: row.tw_uat_master_Id,
      num_manufacturercode: row.num_manufacturercode, txt_manufacturername: row.txt_manufacturername, num_mode_code: row.num_mode_code, txt_model_name: row.txt_model_name, num_model_varient_code: row.num_model_varient_code, txt_model_varient: row.txt_model_varient, num_product: row.num_product, txt_status: row.txt_status, dat_start_date: row.dat_start_date, dat_end_date: row.dat_end_date, num_vehicle_class: row.num_vehicle_class, num_vehicle_sub_class: row.num_vehicle_sub_class, txt_body_type: row.txt_body_type, num_body_type: row.num_body_type, txt_segment: row.txt_segment, num_segement: row.num_segement, num_fuel_type: row.num_fuel_type, txt_fuel_type: row.txt_fuel_type, num_cubic_capacity: row.num_cubic_capacity, num_seating_capacity: row.num_seating_capacity, num_carrying_capacity: row.num_carrying_capacity, num_gross_vehicle_weight: row.num_gross_vehicle_weight, dummyOne: row.dummyOne, dummyTwo: row.dummyTwo, dummyThree: row.dummyThree,
      //***editstate
      errors: {},
      touched: {}
    });
  }

  Tw_uat_masterfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);

    fetch(configData.api_url + 'C_Tw_uat_master/list', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list });
        }
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        this.showToast("Failed to load data", "error");
      });
  }

  Tw_uat_mastersubmitHandler = (e) => {
    e.preventDefault();

    // Validate all fields before submission
    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before submitting", "error");
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append('num_manufacturercode', this.state.num_manufacturercode);
    formData.append('txt_manufacturername', this.state.txt_manufacturername);
    formData.append('num_mode_code', this.state.num_mode_code);
    formData.append('txt_model_name', this.state.txt_model_name);
    formData.append('num_model_varient_code', this.state.num_model_varient_code);
    formData.append('txt_model_varient', this.state.txt_model_varient);
    formData.append('num_product', this.state.num_product);
    formData.append('txt_status', this.state.txt_status);
    formData.append('dat_start_date', this.state.dat_start_date);
    formData.append('dat_end_date', this.state.dat_end_date);
    formData.append('num_vehicle_class', this.state.num_vehicle_class);
    formData.append('num_vehicle_sub_class', this.state.num_vehicle_sub_class);
    formData.append('txt_body_type', this.state.txt_body_type);
    formData.append('num_body_type', this.state.num_body_type);
    formData.append('txt_segment', this.state.txt_segment);
    formData.append('num_segement', this.state.num_segement);
    formData.append('num_fuel_type', this.state.num_fuel_type);
    formData.append('txt_fuel_type', this.state.txt_fuel_type);
    formData.append('num_cubic_capacity', this.state.num_cubic_capacity);
    formData.append('num_seating_capacity', this.state.num_seating_capacity);
    formData.append('num_carrying_capacity', this.state.num_carrying_capacity);
    formData.append('num_gross_vehicle_weight', this.state.num_gross_vehicle_weight);
    formData.append('dummyOne', this.state.dummyOne);
    formData.append('dummyTwo', this.state.dummyTwo);
    formData.append('dummyThree', this.state.dummyThree);

    //***tableData*

    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + 'C_Tw_uat_master/add', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.Tw_uat_masterfetchHandler();
          this.handleOffcanvasClose();
          this.setState({ num_manufacturercode: '', txt_manufacturername: '', num_mode_code: '', txt_model_name: '', num_model_varient_code: '', txt_model_varient: '', num_product: '', txt_status: '', dat_start_date: '', dat_end_date: '', num_vehicle_class: '', num_vehicle_sub_class: '', txt_body_type: '', num_body_type: '', txt_segment: '', num_segement: '', num_fuel_type: '', txt_fuel_type: '', num_cubic_capacity: '', num_seating_capacity: '', num_carrying_capacity: '', num_gross_vehicle_weight: '', dummyOne: '', dummyTwo: '', dummyThree: '', });
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Submit error:", error);
        this.showToast("Failed to save data", "error");
      
        this.setState({ loading: false });});
  }

  Tw_uat_masterupdateHandler = (e) => {
    e.preventDefault();

    // Validate all fields before submission
    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before updating", "error");
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("tw_uat_master_Id", this.state.tw_uat_master_Id);
    formData.append('num_manufacturercode', this.state.num_manufacturercode);
    formData.append('txt_manufacturername', this.state.txt_manufacturername);
    formData.append('num_mode_code', this.state.num_mode_code);
    formData.append('txt_model_name', this.state.txt_model_name);
    formData.append('num_model_varient_code', this.state.num_model_varient_code);
    formData.append('txt_model_varient', this.state.txt_model_varient);
    formData.append('num_product', this.state.num_product);
    formData.append('txt_status', this.state.txt_status);
    formData.append('dat_start_date', this.state.dat_start_date);
    formData.append('dat_end_date', this.state.dat_end_date);
    formData.append('num_vehicle_class', this.state.num_vehicle_class);
    formData.append('num_vehicle_sub_class', this.state.num_vehicle_sub_class);
    formData.append('txt_body_type', this.state.txt_body_type);
    formData.append('num_body_type', this.state.num_body_type);
    formData.append('txt_segment', this.state.txt_segment);
    formData.append('num_segement', this.state.num_segement);
    formData.append('num_fuel_type', this.state.num_fuel_type);
    formData.append('txt_fuel_type', this.state.txt_fuel_type);
    formData.append('num_cubic_capacity', this.state.num_cubic_capacity);
    formData.append('num_seating_capacity', this.state.num_seating_capacity);
    formData.append('num_carrying_capacity', this.state.num_carrying_capacity);
    formData.append('num_gross_vehicle_weight', this.state.num_gross_vehicle_weight);
    formData.append('dummyOne', this.state.dummyOne);
    formData.append('dummyTwo', this.state.dummyTwo);
    formData.append('dummyThree', this.state.dummyThree);

    //***tableData1

    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + 'C_Tw_uat_master/update', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.Tw_uat_masterfetchHandler();
          this.handleOffcanvasClose();
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Update error:", error);
        this.showToast("Failed to update data", "error");
      
        this.setState({ loading: false });});
  }

  componentDidMount() {
    this.Tw_uat_masterfetchHandler();

    //***componentDidMount
  }

  handlenum_manufacturercodeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ num_manufacturercode: fieldValue });
  }; handletxt_manufacturernameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ txt_manufacturername: fieldValue });
  }; handlenum_mode_codeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ num_mode_code: fieldValue });
  }; handletxt_model_nameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ txt_model_name: fieldValue });
  }; handlenum_model_varient_codeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ num_model_varient_code: fieldValue });
  }; handletxt_model_varientChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ txt_model_varient: fieldValue });
  }; handlenum_productChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ num_product: fieldValue });
  }; handletxt_statusChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ txt_status: fieldValue });
  }; handledat_start_dateChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ dat_start_date: fieldValue });
  }; handledat_end_dateChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ dat_end_date: fieldValue });
  }; handlenum_vehicle_classChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ num_vehicle_class: fieldValue });
  }; handlenum_vehicle_sub_classChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ num_vehicle_sub_class: fieldValue });
  }; handletxt_body_typeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ txt_body_type: fieldValue });
  }; handlenum_body_typeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ num_body_type: fieldValue });
  }; handletxt_segmentChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ txt_segment: fieldValue });
  }; handlenum_segementChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ num_segement: fieldValue });
  }; handlenum_fuel_typeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ num_fuel_type: fieldValue });
  }; handletxt_fuel_typeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ txt_fuel_type: fieldValue });
  }; handlenum_cubic_capacityChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ num_cubic_capacity: fieldValue });
  }; handlenum_seating_capacityChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ num_seating_capacity: fieldValue });
  }; handlenum_carrying_capacityChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ num_carrying_capacity: fieldValue });
  }; handlenum_gross_vehicle_weightChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ num_gross_vehicle_weight: fieldValue });
  }; handledummyOneChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyOne: fieldValue });
  }; handledummyTwoChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyTwo: fieldValue });
  }; handledummyThreeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyThree: fieldValue });
  };
  //***inputFunctions

  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };

  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];
    const index = oldData.index;
    data[index] = newData;
    this.setState({ data });
  };

  handleEdit = (row) => {
    console.log(`Editing row with ID ${row.id}`);
  };

  handleDelete = (row, index) => {
    if (!window.confirm(`Are you sure you want to delete this tw_uat_master?`)) {
      return;
    }

    var formData = new FormData();
    formData.append('tw_uat_master_Id', row.tw_uat_master_Id);

    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + 'C_Tw_uat_master/delete', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.Tw_uat_masterfetchHandler();
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Delete error:", error);
        this.showToast("Failed to delete data", "error");
      
        this.setState({ loading: false });});
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };

  // Helper method to render error message
  renderFieldError = (fieldName) => {
    const { errors, touched } = this.state;
    if (errors[fieldName] && touched[fieldName]) {
      return (
        <div className="text-danger mt-1" style={{ fontSize: "0.875rem" }}>
          <i className="bi bi-exclamation-circle me-1"></i>
          {errors[fieldName]}
        </div>
      );
    }
    return null;
  };

  // Auto-generated form field renderer based on inputType and validation options
  renderFormField = (fieldConfig) => {
    const { fieldName, displayName, inputType, validationOptions } = fieldConfig;
    const value = this.state[fieldName] || "";
    const hasError = this.state.errors[fieldName] && this.state.touched[fieldName];

    let inputElement;

    switch (inputType.toLowerCase()) {
      case 'dob_child':
      case 'dob_adult':
      case 'date':
        inputElement = (
          <Form.Control
            type="date"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
          />
        );
        break;

      case 'telephone':
      case 'phone':
        inputElement = (
          <Form.Control
            type="tel"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter 10-digit mobile number"
          />
        );
        break;

      case 'mail':
      case 'email':
        inputElement = (
          <Form.Control
            type="email"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter email address"
          />
        );
        break;

      case 'password':
        inputElement = (
          <Form.Control
            type="password"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter password"
          />
        );
        break;

      case 'number':
        inputElement = (
          <Form.Control
            type="number"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
          />
        );
        break;

      case 'pan':
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value.toUpperCase(), fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="ABCPA1234B"
            maxLength="10"
          />
        );
        break;

      case 'aadhaar':
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value.replace(/\D/g, ''), fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="123456789012"
            maxLength="12"
          />
        );
        break;

      default: // text and other types
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
            maxLength={validationOptions?.maxLength || undefined}
          />
        );
    }

    return (
      <Row key={fieldName}>
        <Col lg="4" md="4">
          <Form.Label>
            {displayName}
            {validationOptions?.isRequired && <span className="text-danger">*</span>}
          </Form.Label>
        </Col>
        <Col lg="8" md="8">
          {inputElement}
          {this.renderFieldError(fieldName)}
        </Col>
      </Row>
    );
  };

  render() {
    const { errors, touched } = this.state;

    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      )
      : this.state.data.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      );

    return (
      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <div
                  id="datatable_wrapper"
                  className="dataTables_wrapper form-inline
                dt-bootstrap no-footer"
                >
                  <Row className="row">
                    <div>
                      <h3 className="logoskybluecolor" style={{ textAlign: "start" }}>TW Vehicle Master</h3>
                    </div>
                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "5px", marginTop: "20px" }}
                    >
                      <Button
                        variant="primary" style={{ float: "right", marginBottom: "10px" }}
                        className="bi bi-plus "
                        onClick={this.handleOffcanvasShow}
                      >
                        New
                      </Button>

                      {/* Enhanced Add Offcanvas */}
                      <Offcanvas
                        show={this.state.show && !this.state.isEditing}
                        onHide={this.handleOffcanvasClose}
                        {...this.props}
                        style={{ width: "500px" }}
                        placement="end"
                        backdrop="true"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>Add Tw_uat_master</Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <Container style={{ "overflowY": "auto", height: "auto" }}>

                            {/* Error Summary */}
                            {Object.keys(errors).length > 0 && (
                              <div className="alert alert-danger mb-3">
                                <strong>Please fix the following errors:</strong>
                                <ul className="mb-0 mt-2">
                                  {Object.entries(errors).map(([field, error]) => (
                                    <li key={field}>{error}</li>
                                  ))}
                                </ul>
                              </div>
                            )}

                            <Row className="divstyle">
                              <Row>
                                <Form>
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Num Manufacturer Code</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlenum_manufacturercodeChange} className="form-control" name="num_manufacturercode" value={this.state.num_manufacturercode} required="required" placeholder="Enter Num Manufacturer Code" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.num_manufacturercode} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Txt Manufacturer Name</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletxt_manufacturernameChange} className="form-control" name="txt_manufacturername" value={this.state.txt_manufacturername} required="required" placeholder="Enter Txt Manufacturer Name" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_manufacturername} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Number Model Code</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlenum_mode_codeChange} className="form-control" name="num_mode_code" value={this.state.num_mode_code} required="required" placeholder="Enter Number Model Code" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.num_mode_code} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Text Model Name</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletxt_model_nameChange} className="form-control" name="txt_model_name" value={this.state.txt_model_name} required="required" placeholder="Enter Text Model Name" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_model_name} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Number Model Variant Code</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlenum_model_varient_codeChange} className="form-control" name="num_model_varient_code" value={this.state.num_model_varient_code} required="required" placeholder="Enter Number Model Variant Code" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.num_model_varient_code} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Text Model Varient</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletxt_model_varientChange} className="form-control" name="txt_model_varient" value={this.state.txt_model_varient} required="required" placeholder="Enter Text Model Varient" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_model_varient} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Number Product</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlenum_productChange} className="form-control" name="num_product" value={this.state.num_product} required="required" placeholder="Enter Number Product" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.num_product} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Text Status</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletxt_statusChange} className="form-control" name="txt_status" value={this.state.txt_status} required="required" placeholder="Enter Text Status" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_status} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Date Start Date</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="date" onChange={this.handledat_start_dateChange} className="form-control" name="dat_start_date" value={this.state.dat_start_date} required="required" placeholder="Enter Date Start Date" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dat_start_date} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Date Enddate</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="date" onChange={this.handledat_end_dateChange} className="form-control" name="dat_end_date" value={this.state.dat_end_date} required="required" placeholder="Enter Date Enddate" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dat_end_date} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Number Vehicle Class</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlenum_vehicle_classChange} className="form-control" name="num_vehicle_class" value={this.state.num_vehicle_class} required="required" placeholder="Enter Number Vehicle Class" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.num_vehicle_class} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Number Vehicle Sub Class</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlenum_vehicle_sub_classChange} className="form-control" name="num_vehicle_sub_class" value={this.state.num_vehicle_sub_class} required="required" placeholder="Enter Number Vehicle Sub Class" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.num_vehicle_sub_class} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Text Body Type</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletxt_body_typeChange} className="form-control" name="txt_body_type" value={this.state.txt_body_type} required="required" placeholder="Enter Text Body Type" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_body_type} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Number Body Type</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlenum_body_typeChange} className="form-control" name="num_body_type" value={this.state.num_body_type} required="required" placeholder="Enter Number Body Type" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.num_body_type} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Text Segment</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletxt_segmentChange} className="form-control" name="txt_segment" value={this.state.txt_segment} required="required" placeholder="Enter Text Segment" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_segment} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Number Segement</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlenum_segementChange} className="form-control" name="num_segement" value={this.state.num_segement} required="required" placeholder="Enter Number Segement" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.num_segement} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Number Fuel Type</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlenum_fuel_typeChange} className="form-control" name="num_fuel_type" value={this.state.num_fuel_type} required="required" placeholder="Enter Number Fuel Type" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.num_fuel_type} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Text Fuel Type</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletxt_fuel_typeChange} className="form-control" name="txt_fuel_type" value={this.state.txt_fuel_type} required="required" placeholder="Enter Text Fuel Type" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_fuel_type} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Number Cubic Capacity</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlenum_cubic_capacityChange} className="form-control" name="num_cubic_capacity" value={this.state.num_cubic_capacity} required="required" placeholder="Enter Number Cubic Capacity" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.num_cubic_capacity} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Number Seating Capacity</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlenum_seating_capacityChange} className="form-control" name="num_seating_capacity" value={this.state.num_seating_capacity} required="required" placeholder="Enter Number Seating Capacity" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.num_seating_capacity} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Number Carrying Capacity</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlenum_carrying_capacityChange} className="form-control" name="num_carrying_capacity" value={this.state.num_carrying_capacity} required="required" placeholder="Enter Number Carrying Capacity" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.num_carrying_capacity} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Number Gross Vehicle Weight</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlenum_gross_vehicle_weightChange} className="form-control" name="num_gross_vehicle_weight" value={this.state.num_gross_vehicle_weight} required="required" placeholder="Enter Number Gross Vehicle Weight" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.num_gross_vehicle_weight} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>DummyOne</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handledummyOneChange} className="form-control" name="dummyOne" value={this.state.dummyOne} required="required" placeholder="Enter DummyOne" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyOne} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>dummyTwo</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handledummyTwoChange} className="form-control" name="dummyTwo" value={this.state.dummyTwo} required="required" placeholder="Enter dummyTwo" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyTwo} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>dummyThree</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handledummyThreeChange} className="form-control" name="dummyThree" value={this.state.dummyThree} required="required" placeholder="Enter dummyThree" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyThree} </div>
                                  </Row><br />
                                  {/* Auto-generated form content with validation */}
                                </Form>
                              </Row>
                            </Row>
                            <Row>
                              <Col
                                className="d-flex justify-content-end"
                                style={{ marginRight: "50px" }}
                              >
                                <Button
                                  className="button"
                                  variant="success"
                                  onClick={this.Tw_uat_mastersubmitHandler}
                                  disabled={!this.isFormValid()}
                                  style={{
                                    marginTop: "20px",
                                  }}
                                >
                                  Save
                                </Button>
                              </Col>
                            </Row>
                          </Container>
                        </Offcanvas.Body>
                      </Offcanvas>

                      {/* Enhanced Edit Offcanvas */}
                      {this.state.isEditing && (
                        <Offcanvas
                          show={this.state.isEditing}
                          onHide={this.handleOffcanvasClose}
                          {...this.props}
                          style={{ width: "500px" }}
                          placement="end"
                          backdrop="true"
                        >
                          <Offcanvas.Header closeButton>
                            <Offcanvas.Title>Edit Tw_uat_master</Offcanvas.Title>
                          </Offcanvas.Header>
                          <Offcanvas.Body>
                            <Container style={{ "overflowY": "auto", height: "auto" }}>

                              {/* Error Summary */}
                              {Object.keys(errors).length > 0 && (
                                <div className="alert alert-danger mb-3">
                                  <strong>Please fix the following errors:</strong>
                                  <ul className="mb-0 mt-2">
                                    {Object.entries(errors).map(([field, error]) => (
                                      <li key={field}>{error}</li>
                                    ))}
                                  </ul>
                                </div>
                              )}

                              <Row className="divstyle">
                                <Row>
                                  <Form>
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Num Manufacturer Code</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlenum_manufacturercodeChange} className="form-control" name="num_manufacturercode" value={this.state.num_manufacturercode} required="required" placeholder="Enter Num Manufacturer Code" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.num_manufacturercode} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Txt Manufacturer Name</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletxt_manufacturernameChange} className="form-control" name="txt_manufacturername" value={this.state.txt_manufacturername} required="required" placeholder="Enter Txt Manufacturer Name" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_manufacturername} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Number Model Code</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlenum_mode_codeChange} className="form-control" name="num_mode_code" value={this.state.num_mode_code} required="required" placeholder="Enter Number Model Code" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.num_mode_code} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Text Model Name</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletxt_model_nameChange} className="form-control" name="txt_model_name" value={this.state.txt_model_name} required="required" placeholder="Enter Text Model Name" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_model_name} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Number Model Variant Code</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlenum_model_varient_codeChange} className="form-control" name="num_model_varient_code" value={this.state.num_model_varient_code} required="required" placeholder="Enter Number Model Variant Code" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.num_model_varient_code} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Text Model Varient</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletxt_model_varientChange} className="form-control" name="txt_model_varient" value={this.state.txt_model_varient} required="required" placeholder="Enter Text Model Varient" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_model_varient} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Number Product</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlenum_productChange} className="form-control" name="num_product" value={this.state.num_product} required="required" placeholder="Enter Number Product" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.num_product} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Text Status</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletxt_statusChange} className="form-control" name="txt_status" value={this.state.txt_status} required="required" placeholder="Enter Text Status" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_status} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Date Start Date</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="date" onChange={this.handledat_start_dateChange} className="form-control" name="dat_start_date" value={this.state.dat_start_date} required="required" placeholder="Enter Date Start Date" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dat_start_date} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Date Enddate</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="date" onChange={this.handledat_end_dateChange} className="form-control" name="dat_end_date" value={this.state.dat_end_date} required="required" placeholder="Enter Date Enddate" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dat_end_date} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Number Vehicle Class</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlenum_vehicle_classChange} className="form-control" name="num_vehicle_class" value={this.state.num_vehicle_class} required="required" placeholder="Enter Number Vehicle Class" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.num_vehicle_class} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Number Vehicle Sub Class</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlenum_vehicle_sub_classChange} className="form-control" name="num_vehicle_sub_class" value={this.state.num_vehicle_sub_class} required="required" placeholder="Enter Number Vehicle Sub Class" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.num_vehicle_sub_class} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Text Body Type</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletxt_body_typeChange} className="form-control" name="txt_body_type" value={this.state.txt_body_type} required="required" placeholder="Enter Text Body Type" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_body_type} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Number Body Type</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlenum_body_typeChange} className="form-control" name="num_body_type" value={this.state.num_body_type} required="required" placeholder="Enter Number Body Type" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.num_body_type} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Text Segment</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletxt_segmentChange} className="form-control" name="txt_segment" value={this.state.txt_segment} required="required" placeholder="Enter Text Segment" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_segment} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Number Segement</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlenum_segementChange} className="form-control" name="num_segement" value={this.state.num_segement} required="required" placeholder="Enter Number Segement" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.num_segement} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Number Fuel Type</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlenum_fuel_typeChange} className="form-control" name="num_fuel_type" value={this.state.num_fuel_type} required="required" placeholder="Enter Number Fuel Type" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.num_fuel_type} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Text Fuel Type</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletxt_fuel_typeChange} className="form-control" name="txt_fuel_type" value={this.state.txt_fuel_type} required="required" placeholder="Enter Text Fuel Type" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_fuel_type} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Number Cubic Capacity</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlenum_cubic_capacityChange} className="form-control" name="num_cubic_capacity" value={this.state.num_cubic_capacity} required="required" placeholder="Enter Number Cubic Capacity" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.num_cubic_capacity} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Number Seating Capacity</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlenum_seating_capacityChange} className="form-control" name="num_seating_capacity" value={this.state.num_seating_capacity} required="required" placeholder="Enter Number Seating Capacity" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.num_seating_capacity} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Number Carrying Capacity</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlenum_carrying_capacityChange} className="form-control" name="num_carrying_capacity" value={this.state.num_carrying_capacity} required="required" placeholder="Enter Number Carrying Capacity" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.num_carrying_capacity} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Number Gross Vehicle Weight</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlenum_gross_vehicle_weightChange} className="form-control" name="num_gross_vehicle_weight" value={this.state.num_gross_vehicle_weight} required="required" placeholder="Enter Number Gross Vehicle Weight" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.num_gross_vehicle_weight} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>DummyOne</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handledummyOneChange} className="form-control" name="dummyOne" value={this.state.dummyOne} required="required" placeholder="Enter DummyOne" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyOne} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>dummyTwo</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handledummyTwoChange} className="form-control" name="dummyTwo" value={this.state.dummyTwo} required="required" placeholder="Enter dummyTwo" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyTwo} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>dummyThree</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handledummyThreeChange} className="form-control" name="dummyThree" value={this.state.dummyThree} required="required" placeholder="Enter dummyThree" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyThree} </div>
                                    </Row><br />
                                    {/* Auto-generated form content with validation */}
                                  </Form>
                                </Row>
                              </Row>
                              <Row>
                                <Col
                                  className="d-flex justify-content-end"
                                  style={{ marginRight: "50px" }}
                                >
                                  <Button
                                    className="button"
                                    variant="success"
                                    onClick={this.Tw_uat_masterupdateHandler}
                                    disabled={!this.isFormValid()}
                                    style={{
                                      marginTop: "20px",
                                    }}
                                  >
                                    Update
                                  </Button>
                                </Col>
                              </Row>
                            </Container>
                          </Offcanvas.Body>
                        </Offcanvas>
                      )}
                      {/*offcanvas is over */}
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <div style={{ "marginRight": "5px" }}>
                      {/* searchbar,pagination,filter */}
                      <input
                        type="text"
                        style={{ float: "left", marginBottom: "10px" }}
                        onChange={this.handleFilter}
                        placeholder="Search..."
                      />
                      <DataTable
                        data={paginatedData}
                        columns={this.state.tableClms}
                        pagination
                        paginationServer
                        paginationTotalRows={
                          this.state.filteredData
                            ? this.state.filteredData.length
                            : this.state.data.length
                        }
                        onChangeRowsPerPage={this.handlePerRowsChange}
                        onChangePage={this.handlePageChange}
                        paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
                        paginationPerPage={100}
                        keyField="id"
                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                      />
                    </div>
                  </Row>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    );
  }
}